/**
 * Environment host/API defaults for Express CSP (csp.config.js) and the CRA
 * client (src/utils/constants.ts). Override with REACT_APP_* / APP_ENV.
 *
 * External content links (CDN, help center, etc.) live as plain constants in
 * src/utils/constants.ts — not here and not in .env.
 */
module.exports = {
  production: {
    siteUrl: "https://vlemobile.com",
    appUrl: "https://app.vlemobile.com",
    apiUrl: "https://api.vlemobile.com",
    appOrigins: [
      "https://app.vlemobile.com",
      "https://vlemobile.com",
      "https://www.vlemobile.com",
    ],
  },
  development: {
    siteUrl: "https://vle-next.appening.xyz",
    appUrl: "https://vle.appening.xyz",
    apiUrl: "https://api-vle.appening.xyz",
    appOrigins: [
      "https://vle-next.appening.xyz",
      "https://vle.appening.xyz",
      "http://localhost:3000",
      "http://127.0.0.1:3000",
    ],
  },
  staging: {
    siteUrl: "https://vle-next.appening.xyz",
    appUrl: "https://vle.appening.xyz",
    apiUrl: "https://api-vle.appening.xyz",
    appOrigins: [
      "https://vle-next.appening.xyz",
      "https://vle.appening.xyz",
    ],
  },
};
